ScoreTrekBattle.Session = (function() {
    var _this, STATUS, CONFIG, ELEMENT;

    CONFIG = {
        POLL_DELAY: 2000,
        MULTI_TAB_TIMEOUT: 2000,
        TAB_PREFIX: 'Session.Tab.',
        POLL_ERROR_ICON: {
            instableConnection: '<i class="fa-solid fa-wifi"></i>',
            multipleTabs: '<i class="fa-solid fa-rectangle-history"></i>'
        }
    };

    STATUS = {
        appMode: false,
        firstLoad: true,
        AUTH: {
            player: false,
            adminMode: false
        },
        adminClubSelector: null,
        tabId: '',
        pollError: {
            instableConnection: false,
            multipleTabs: false
        }
    };

    ELEMENT = {};

    function resetAuth() {
        STATUS.AUTH = {
            player: false,
            adminMode: !!chmStorage.getSession('AdminMode')
        };
    }

    function updateAuth() {
        var player, hasPlayer, clubId, isAdminMode;

        hasPlayer = !!STATUS.AUTH.player;
        player = hasPlayer ? STATUS.AUTH.player : {};

        clubId = (player.club) ? player.club.id : '';
        isAdminMode = ((player.access_level === 'sys_admin') && STATUS.AUTH.adminMode);

        ScoreTrekBattle.$body.attr('data-authorized', hasPlayer ? 'yes' : 'no');
        ScoreTrekBattle.$body.attr('data-authorized-player', player.id || '');
        ScoreTrekBattle.$body.attr('data-authorized-club', clubId);
        ScoreTrekBattle.$body.attr('data-battle-manager', isBattleManager() ? 'yes' : 'no');
        ScoreTrekBattle.$body.attr('data-club-admin', player.club_admin ? 'yes' : 'no');
        ScoreTrekBattle.$body.attr('data-access-level', hasPlayer ? player.access_level : 'unauthorized');
        ScoreTrekBattle.$body.attr('data-admin-mode', isAdminMode ? 'yes' : 'no');
        ScoreTrekBattle.$body.attr('data-is-pro-player', !!player.pro_account ? 'yes' : 'no');
        $('[data-id="authClubName"]')[player.club ? 'text' : 'html'](player.club ? player.club.name : `<i>${__i18n('clubMenu/noClubAssigned')}</i>`);
        $('[data-id="authClubLogo"]').css('background-image', `url('${player.club ? player.club.logo : ScoreTrekBattle.ASSETS.PLACEHOLDER.club}')`);
        $('[data-id="authPlayerName"]').text(hasPlayer ? `${player.first_name} ${player.last_name}` : '');
        $('[data-id="authPlayerAvatar"]').css('background-image', `url('${hasPlayer ? player.thumbnail : ''}')`);

        try {
            ELEMENT.$authCss.remove();
        } catch(ignore) {}

        ELEMENT.$authCss = $('<style>').attr('type', 'text/css').text([
            `body:not([data-admin-mode="yes"]) [data-show-for-club]${(clubId !== '') ? `:not([data-show-for-club="${clubId}"])` : ''} {`,
                `display: none !important;`,
            `}`,
            `body[data-admin-mode="yes"] [data-hide-for-club],`,
            `[data-hide-for-club="${clubId}"] {`,
                `display: none !important;`,
            `}`
        ].join(''));
        $('head').append(ELEMENT.$authCss);
    }

    function isBattleManager() {
        return (STATUS.AUTH.player && STATUS.AUTH.player.battle_manager);
    }

    function isSysAdmin() {
        return (STATUS.AUTH.player && (STATUS.AUTH.player.access_level === 'sys_admin'));
    }

    function isClubUser(clubId) {
        return (STATUS.AUTH.player && (STATUS.AUTH.player.club_id === clubId));
    }

    function loadPlayer() {
        return new Promise(function(resolve) {
            var player;

            player = false;

            ScoreTrekBattle.View.loading('Session.loadPlayer', true);
            Api.request('/battle/player').then(result => {
                if (result && result.player) {
                    player = result.player;
                }
            }).catch(
                ignore => {}
            ).finally(() => {
                ScoreTrekBattle.View.loading('Session.loadPlayer', false);
                updatePlayer(player);
                resolve(player);
            });
        });
    }

    function updatePlayer(player) {
        hasPlayer = !!STATUS.AUTH.player;
        if (player) {
            STATUS.AUTH.player = player;
        } else {
            resetAuth();
        }
        updateAuth();
    }

    function restoreSession() {
        var token;

        ScoreTrekBattle.View.loading('Session.restoreSession', true);
        Api.request('/battle/token/renew', {revert: true}).then(result => {
            if (result && result.token) {
                token = result.token;
            }
        }).catch(
            ignore => {}
        ).finally(() => {
            ScoreTrekBattle.View.loading('Session.restoreSession', false);
            Api.setToken(token);
            loadPlayer().then(player => {
                sessionReady(!!player, false, false);
            });
        });
    }

    function loginAs(playerId) {
        var token;

        ScoreTrekBattle.View.loading('Session.restoreSession', true);
        Api.request('/battle/login/as', {playerId: playerId})
            .then(result => {
                Api.setToken(result.token);
                location.reload();
                // loadPlayer().then(player => {
                //     sessionReady(!!player, false, false);
                // });
            })
            .catch(error => {
                chmDialog.error(error);
            })
            .finally(() => {
                ScoreTrekBattle.View.loading('Session.restoreSession', false);
            })
        ;
    }

    function sessionReady(isAuthenticated, triggerLogin, triggerLogout) {
        if (STATUS.firstLoad) {
            STATUS.firstLoad = false;
            ScoreTrekBattle.Event.trigger('session.ready', isAuthenticated);
            return;
        }
        if (isAuthenticated && triggerLogin) {
            ScoreTrekBattle.Event.trigger('session.login');
        } else if (!isAuthenticated && triggerLogout) {
            ScoreTrekBattle.Event.trigger('session.logout');
        }
    }

    function loginWithApp() {
        ScoreTrekBattle.View.loading('Session.loginWithApp', true);
        Api.toApp('loaded');
        Api.toApp('authenticate').then(result => {
            ScoreTrekBattle.View.loading('Session.loginWithApp', false);

            if (!result || !result.token) {
                connectionError(result.message || 'appInteractionFailed', false);
                return;
            }

            if (result.token.error) {
                Api.setToken();

                connectionError(result.token.message || 'appInteractionFailed', false);

                return;
            }

            Api.setToken(result.token);
            loadPlayer().then(player => {
                sessionReady(!!player, true, false);
                if (!player) {
                    connectionError('appInteractionFailed', false);
                }
            });
        });
    }

    function loginWithCode() {
        var dialog, polling, codeResult;

        function poll() {
            if (polling) {
                setTimeout(function() {
                    Api.request(
                        '/battle/login/poll',
                        {
                            value: codeResult.value,
                            code: codeResult.code
                        }
                    ).then(pollResult => {
                        if (pollResult) {
                            pollError('instableConnection', false);
                            if (pollResult.token) {
                                endPoll(pollResult.token);
                            }
                        } else {
                            pollError('instableConnection', true);
                        }
                    }).catch(error => {
                        pollError('instableConnection', true);
                    }).finally(() => {
                        poll();
                    });
                }, CONFIG.POLL_DELAY);
            }
        }

        function pollError(type, isActive) {
            let messages, hasMessages, html, $messages;

            if (!STATUS.pollError.hasOwnProperty(type)) {
                return;
            }

            STATUS.pollError[type] = isActive;

            messages = [];

            Object.keys(STATUS.pollError).forEach(errorType => {
                if (!STATUS.pollError[errorType]) {
                    return;
                }

                messages.push(`<div class="${(messages.length > 0) ? 'mt-medium' : ''}">${CONFIG.POLL_ERROR_ICON[errorType]} ${__i18n(`error/${errorType}`)}</div>`);
            });

            hasMessages = (messages.length > 0);
            html = messages.join('');

            if (hasMessages) {
                $messages = dialog.find('[data-id="pollErrorMessage"]');

                if ($messages.html() !== html) {
                    $messages.html(html);
                }
            }

            dialog.find('[data-id="pollError"]').stop()[hasMessages ? 'slideDown' : 'slideUp']();
        }

        function endPoll(token) {
            polling = false;
            Api.setToken(token);
            dialog.close();
            loadPlayer().then(player => {
                sessionReady(!!player, true, false);
                if (!player && (token !== null)) {
                    connectionError('appInteractionFailed', true);
                }
            });
        }

        function watchTabs() {
            let timer, hasMultipleTabsCurrent;

            hasMultipleTabsCurrent = false;

            function updateTabs() {
                let hasMultipleTabs;

                hasMultipleTabs = _this.hasMultipleTabs();

                if (hasMultipleTabsCurrent !== hasMultipleTabs) {
                    hasMultipleTabsCurrent = hasMultipleTabs;
                    pollError('multipleTabs', hasMultipleTabsCurrent);
                }
            }

            updateTabs();

            timer = setInterval(() => {
                if (!polling) {
                    clearInterval(timer);
                    return;
                }

                updateTabs();

            }, 1000);
        }

        ScoreTrekBattle.View.loading('Session.loginWithCode', true);

        Api.request('/battle/login/code').then(result => {
            codeResult = result;
            dialog = chmDialog({
                title: __i18n('dialog/login/title'),
                content: $('<div>').append(
                    $('<div>').addClass('mb-medium').html(__i18n('dialog/login/text', {appUrl: ScoreTrekBattle.ENV.APP})),
                    $('<div>').addClass('text-strong').html(__i18n('dialog/login/code')),
                    $('<div>').addClass('mb-small text-huge text-strong text-blue').text(codeResult.code),
                    $('<div>').addClass('pb-medium').attr('data-id', 'pollError').hide().append(
                        $('<div>').addClass('bg-color-red p-small ').attr('data-id', 'pollErrorMessage')
                    ),
                    $('<div>').addClass('qrCode').append(chmQrCode(codeResult.url)),
                    $('<div>').addClass('mt-small text-decent text-small').html(__i18n('dialog/login/notice'))
                ),
                onShow: function() {
                    polling = true;
                    watchTabs();
                    poll();
                },
                afterClose: function() {
                    polling = false;
                }
            });
        }).catch(() => {
            connectionError('noConnectionToServer', true);
        }).finally(() => {
            ScoreTrekBattle.View.loading('Session.loginWithCode', false);
        });
    }

    function logout() {
        ScoreTrekBattle.View.loading('Session.logout', true);
        Api.request('/battle/token/revert').catch(ignore => {}).finally(() => {
            ScoreTrekBattle.View.loading('Session.logout', false);
            Api.setToken();
            updatePlayer(false);
            sessionReady(false, false, true);
        });
    }

    function connectionError(errorName, closeable) {
        chmDialog({
            title: __i18n('dialog/login/title'),
            content: __i18n(`error/${errorName}`),
            buttons: [
                {
                    label: __i18n(closeable ? 'button/close' : 'button/retry'),
                    action: function() {
                        if (!closeable) {
                            ScoreTrekBattle.View.reload();
                        }
                    }
                }
            ]
        });
    }

    function hasMultipleTabs() {
        let tabsCount, nowOffset;

        tabsCount = 0;
        nowOffset = (new Date()).getTime() - CONFIG.MULTI_TAB_TIMEOUT;

        Object.keys(localStorage).forEach(key => {
            let timestamp;

            if (!key.startsWith(CONFIG.TAB_PREFIX)) {
                return;
            }

            timestamp = parseInt(localStorage.getItem(key), 10);

            if (timestamp < nowOffset) {
                localStorage.removeItem(key);
                return;
            }

            tabsCount++;
        });

        return (tabsCount > 1);
    }

    function keepTabAlive() {
        localStorage.setItem(`${CONFIG.TAB_PREFIX}${STATUS.tabId}`, (new Date()).getTime());
    }

    _this = {
        appMode: function(isAppMode) {
            STATUS.appMode = !!isAppMode;
            ScoreTrekBattle.$body.attr('data-mode', STATUS.appMode ? 'app' : 'default');
        },
        isAppMode: function() {
            return STATUS.appMode;
        },
        isBattleManager: function() {
            return isBattleManager();
        },
        isSysAdmin: function() {
            return isSysAdmin();
        },
        isClubUser: function(clubId) {
            return isClubUser(clubId);
        },
        isAdminMode: function() {
            return STATUS.AUTH.adminMode;
        },
        hasPlayer: function() {
            return !!STATUS.AUTH.player;
        },
        getPlayer: function() {
            return DataHandler.cloneObject(STATUS.AUTH.player);
        },
        getPlayerId: function() {
            return STATUS.AUTH.player ? STATUS.AUTH.player.id : '';
        },
        getPlayerClub: function() {
            return STATUS.AUTH.player ? STATUS.AUTH.player.club : null;
        },
        showLoginNotice: function() {
            chmDialog.info(__i18n('dialog/loginRequired/text'), __i18n('dialog/loginRequired/title'), __i18n('button/gotIt'));
        },
        renderClubList: function(view) {
            if (!ScoreTrekBattle.CONFIG.clubs || !view.controls.adminClubId) {
                return;
            }

            STATUS.adminClubSelector = view.controls.adminClubId;

            view.controls.adminClubId.setOptions(
                DataHandler.arrayToOptions(ScoreTrekBattle.CONFIG.clubs, 'id', 'name'),
                {
                    '': `-- ${__i18n('player/noClubAssigned')} --`
                }
            );

            STATUS.adminClubSelector.set(chmStorage.getSession('AdminClubId'));
            STATUS.adminClubSelector.on('change', () => {
                chmStorage.setSession('AdminClubId', STATUS.adminClubSelector.get());
                ScoreTrekBattle.View.reload();
            });
        },
        getClubId: function() {
            return _this.getAdminClubId() || ((STATUS.AUTH.player && STATUS.AUTH.player.club) ? STATUS.AUTH.player.club.id : '');
        },
        getAdminClubId: function() {
            if (!STATUS.AUTH.adminMode || !STATUS.adminClubSelector) {
                return '';
            }
            return STATUS.adminClubSelector.get();
        },
        hasMultipleTabs: function() {
            return hasMultipleTabs();
        }
    };

    ScoreTrekBattle.Event.on('action.loginRequired', function(context) {
        _this.showLoginNotice();
    });

    ScoreTrekBattle.Event.on('action.login', function() {
        updatePlayer(false);
        if (STATUS.appMode) {
            loginWithApp();
        } else {
            loginWithCode();
        }
    });

    ScoreTrekBattle.Event.on('action.player.loginAs', function() {
        loginAs(this.dataset.playerId);
    });

    ScoreTrekBattle.Event.on('action.session.restore', function() {
        updatePlayer(false);
        if (STATUS.appMode) {
            loginWithApp();
        } else {
            restoreSession();
        }
    });

    ScoreTrekBattle.Event.on('action.logout', function() {
        logout();
    });

    ScoreTrekBattle.Event.on('action.adminMode.toggle', function() {
        STATUS.AUTH.adminMode = !STATUS.AUTH.adminMode;
        chmStorage.setSession('AdminMode', STATUS.AUTH.adminMode);
        updateAuth();
        ScoreTrekBattle.Event.trigger('adminMode.toggle', STATUS.AUTH.adminMode);
    });

    ScoreTrekBattle.Event.on('session.logout', function() {
        if (STATUS.appMode) {
            connectionError('parallelSessionEnded', false);
        }
    });

    ScoreTrekBattle.Event.on('api.token.update', function() {
        var playerId;
        playerId = STATUS.AUTH.player ? STATUS.AUTH.player.id : false;
        loadPlayer().then(player => {
            updatePlayer(player);
            if (player && (!playerId || (player.id !== playerId))) {
                ScoreTrekBattle.Event.trigger('session.login');
            } else if (!player && playerId) {
                ScoreTrekBattle.Event.trigger('session.logout');
            }
        });
    });

    ScoreTrekBattle.Event.on('app.to.battle.reauthenticate', function() {
        Api.refreshTokenFromApp();
    });

    window.addEventListener('load', () => {
        resetAuth();

        hasMultipleTabs();
        setTimeout(hasMultipleTabs, CONFIG.MULTI_TAB_TIMEOUT + 1000);

        STATUS.tabId = DataHandler.id();

        keepTabAlive();
        setInterval(() => {
            keepTabAlive();
        }, 500);
    });

    // clean-up multiple tabs on load
    _this.hasMultipleTabs();

    return _this;
})();